import styled, { css } from "styled-components";
import { theme } from "../../../config";
import { Col, Select, Tag } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { Button } from "../../atoms/Button";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${theme.colors.custom.background};
  padding: 57px 83px 15px 83px;
  overflow: auto;

  @media (max-width: 900px) {
    padding: 57px 50px 15px;
  }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: column;
`;

const StickyHeaderElem = css`
  position: sticky;
  top: 0;
`;

export const LeftSideWrapper = styled.div`
  display: flex;
  padding-right: 12px;
  ${StickyHeaderElem}
`;

export const RightSideWrapper = styled.div`
  ${StickyHeaderElem}
`;

export const Header = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  z-index: 1;
  background: ${theme.colors.custom.background};
  margin-top: -28px;
  position: sticky;
  top: -65px;
  padding-top: 30px;
  padding-bottom: 20px;
`;

export const BackIcon = styled.img`
  margin-top: 12px;
  margin-right: 15px;
  cursor: pointer;
  height: 21px;
`;

export const HeaderText = styled.h1`
  font-family: Orkney Bold;
  font-size: 34px;
  line-height: 48px;
  margin: 0;
`;

export const ButtonsWrapper = styled.div`
  right: 0;
  justify-content: space-between;
`;

export const Body = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  margin-top: 20px;
`;

export const TabWrapper = styled.div`
  width: 60%;
  margin-right: 24px;
`;

export const RightDivsWrapper = styled.div`
  width: 40%;
`;

const RightDivWrapperStyle = css`
  background: ${theme.colors.white};
  margin-bottom: 24px;
  padding: 0 31px 25px 30px;
  border-radius: 8px;
  overflow: auto;
  display: block;
  ${theme.defaultBoxShadow}
`;

export const CommentsWrapper = styled.div`
  height: 520px;
  ${RightDivWrapperStyle}
`;
export const RecruitmentPhaseWrapper = styled.div`
  ${RightDivWrapperStyle}
  padding-top: 25px;

  & > div:not(:last-child) {
    margin-bottom: 26px;
  }
`;

export const FlexDiv = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const DateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  .ant-picker-clear {
    display: none;
  }
`;

export const RecruitmentPhaseTag = styled(Tag)<{ $isFailed?: any }>`
  border-radius: 4px;
  margin: 0;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */

  ${(props) => {
    return props.$isFailed
      ? ""
      : `&:hover {
        border-color: ${theme.colors.custom.darkblue1} !important;
        box-shadow: inset 0 0 100px 100px ${theme.colors.custom.darkblue1} !important;
      }`;
  }}
`;

export const StatusWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RecruitmentHeader = styled.span`
  font-family: "Orkney Bold";
  font-size: 16px;
  color: ${theme.colors.custom.darkblue3};
`;

export const FailedReasonWrapped = styled.div`
  margin-top: 20px;
`;

export const StarIcon = styled.img`
  margin-left: 8px;
  margin-bottom: 9px;
  width: 30px;
  height: 30px;
`;

export const SelectStyled = styled(Select)<{ disabled: boolean }>`
  margin-top: 4px;
  .ant-select-selector {
    padding: 0px 25px 0px 7px;
  }

  .ant-select-arrow {
    color: #000000;
  }

  &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    color: #8e8c8c;
    border-radius: 4px;
    ${theme.defaultInputStyle}
    &:hover {
      border: 1px solid ${(props: { disabled: boolean }) => props.disabled ? '#8e8c8c' : theme.colors.secondary } !important;
    }

    @media ${theme.breakpoints.mobileAndTablet} {
      height: 30px;
      font-size: 12.6px;
      line-height: 16px;
      padding-top: 0;
      width: 100%;
    }
    border: 1px solid;
  }

  .ant-select-selection-overflow {
    @media (min-width: 1025px) and (max-width: 1238px) {
      padding-top: 5px;
    }
  }

  .ant-select-selection-overflow-item-rest .ant-select-selection-item {
    padding: 2px 5px 2px 5px !important;
    background: none !important;
    height: 22px !important;
    font-size: 12px !important;
    color: ${(props: { disabled: boolean }) =>
      props.disabled ? "#C5C5C5" : theme.colors.white} !important;
    background: ${(props: { disabled: boolean }) =>
      props.disabled ? "#8B8B8B" : theme.colors.custom.darkblue3} !important;
  }

  .ant-select-selection-overflow-item-rest .ant-select-selection-item:disabled {
    background: #8b8b8b !important;
    color: #c5c5c5 !important;
  }

  &.ant-select:not(.ant-select-customize-input)
    .ant-select-selector:hover:enabled {
    border: 1px solid ${theme.colors.secondary};
  }

  .ant-select-selection-item {
    padding: 0px 8px;
    border-radius: 4px;
    font-size: 12px;
    color: ${(props: { disabled: boolean }) =>
      props.disabled ? "#C5C5C5" : theme.colors.white} !important;
    background: ${(props: { disabled: boolean }) =>
      props.disabled ? "#8B8B8B" : theme.colors.custom.darkblue3} !important;
  }

  .ant-select-selection-overflow-item-rest .ant-select-selection-item {
    padding-top: 2px;
    background: white;
    color: #111111;
    border: none;
  }

  .anticon-close {
    color: ${theme.colors.white};
  }

  .ant-select-selection-placeholder {
    text-align: left;
    padding-left: 2px;
  }
`;

export const DownOutlinedStyle = styled(DownOutlined)`
  position: sticky;
  right: 0;
  margin-left: -24px;
  margin-right: 7px;
`;

export const SaveInterviewersButton = styled(Button)`
  background-color: ${theme.colors.secondary};
  color: ${theme.colors.white};
  width: 100%;
  padding: 0 10px 0 10px;

  @media (max-width: 1670px) {
    padding: 0;
  }

  &:disabled {
    background: ${theme.colors.neutral.black5};
    border: 1px solid ${theme.colors.neutral.black5};
    color: ${theme.colors.neutral.black2};
  }
`;

export const ButtonWrapper = styled(Col)`
  display: flex;
  justify-content: flex-end;
  align-items: end;
`;

export const NoteStyled = styled.span`
  color: ${theme.colors.custom.darkblue3};
  opacity: 0.8;
  font-size: 12px;
  font-family: Roboto;
`;
